import React from "react";
import cx from "classnames";
import ButtonCopy from "../ButtonCopy/ButtonCopy";
import Input from "Components/input/Input";
import s from "./copyableItem.scss";

const CopyableItem = ({ title, value, asInput = false, disabled = false }) => (
  <div className={cx("expand", { [s.copyableItem]: !asInput, [s.copyableItemInput]: asInput })}>
    {asInput ? (
      <Input value={value} disabled />
    ) : (
      <div className="inputFull2">
        <div className="settingTitle">{title}</div>
        <div className="sectionInfo">{value}</div>
      </div>
    )}
    <ButtonCopy value={value} disabled={disabled} />
  </div>
);

export default CopyableItem;
